import React, { useState, useEffect, useContext } from "react";
import axios from "../../../../axios/index";
import { UserContext } from "../../../Context/UserContextProvider";
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { requestResponseValidate } from "./requestResponseValidate";

// Styles
import styles from "../../DashboardReuseAbleComponents/AddNewFile.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

export default function RequestResponseForm({ id }) {
  const { userToken } = useContext(UserContext);
  const history = useHistory();
  const [errors, setErrors] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [filesCode, setFilesCode] = useState({
    fileID1: "",
    fileID2: "",
    fileID3: "",
    fileID4: "",
    fileID5: "",
    fileID6: "",
    description: "",
  });

  useEffect(() => {
    setErrors(requestResponseValidate(filesCode));
  }, [filesCode]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
      <div className={`mt-3 mb-5 px-4 ${Dstyles.container}`} dir="rtl">
        <div className="container-fluid py-2 mb-3">
          {/* Type Header start */}
          <div className="text-end mt-3 mb-5" dir="rtl">
            <div className={`mt-2 ${Dstyles.text1}`}>پاسخ به درخواست</div>
          </div>
          {/* Type Header end */}

          <div className="text-end mt-3" dir="rtl">
            <div className={`my-3 ${Dstyles.commition_text1}`}>شناسه فایل‌های مورد نظر را وارد کنید</div>
          </div>

          <div className="w-100 d-flex flex-wrap justify-content-between align-items-center my-2">
            <FilesInput value={filesCode.fileID1} name="fileID1" title="فایل اول" changeHandler={changeHandler} />
            <FilesInput value={filesCode.fileID2} name="fileID2" title="فایل دوم" changeHandler={changeHandler} />
            <FilesInput value={filesCode.fileID3} name="fileID3" title="فایل سوم" changeHandler={changeHandler} />
            <FilesInput value={filesCode.fileID4} name="fileID4" title="فایل چهارم" changeHandler={changeHandler} />
            <FilesInput value={filesCode.fileID5} name="fileID5" title="فایل پنجم" changeHandler={changeHandler} />
            <FilesInput value={filesCode.fileID6} name="fileID6" title="فایل ششم" changeHandler={changeHandler} />
          </div>

          <div className="w-100 d-flex flex-column justify-content-center align-items-start my-5">
            <div className={`mb-3 ${styles.text1}`}>توضیحات</div>
            <textarea
              id="menuone"
              type="text"
              name="description"
              value={filesCode.description}
              onChange={changeHandler}
              className={`w-100 px-3 pt-3 ${styles.textarea}`}
              placeholder="توضیحات خود را وارد کنید"></textarea>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center flex-wrap my-2">
            {btnLoader ? (
              <div className={Dstyles.btn_loader_container}>
                <div className={Dstyles.btn_spinner}></div>
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center my-md-0 my-2">
                <button className={styles.save_btn} type="" onClick={submitHandler}>
                  ارسال
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );

  function submitHandler() {
    if (!Object.keys(errors).length) {
      notify("درحال ارسال پاسخ شما", "success");
    } else {
      notify("لطفا حداقل یک شناسه فایل را وارد کنید!", "error");
    }
  }

  function notify(text, type) {
    if (type === "success") {
      setBtnLoader(true);
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      postHandler();
      setBtnLoader(false);
    } else if (type === "posted") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    } else if (type === "posted-error") {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      history.push("/requested-files");
      setBtnLoader(false);
    } else {
      setBtnLoader(true);
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function postHandler() {
    try {
      const valuesArray = Object.values(filesCode);
      valuesArray.pop();
      setBtnLoader(true);
      var data = new FormData();
      data.append("RequestFileId", id);
      data.append("Description", filesCode.description);
      for (const id of valuesArray) {
        if (id) {
          data.append("EstateCodes", id?.toString());
          // console.log(id)
        }
      }

      const apiData = await axios.post("RequestFile/AddSuggestionByConsultant", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      notify("پاسخ شما با موفقیت فرستاده شد", "posted");
      history.push("/requested-files");
    } catch (error) {
      notify("خطایی رخ داد", "posted-error");
    }
    setBtnLoader(false);
  }

  function changeHandler(event) {
    setFilesCode(prev => {
      return { ...prev, [event.target.name]: event.target.value };
    });
  }
}

function FilesInput({ value, name, title, changeHandler }) {
  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-start my-3">
        <div className={`mb-3 ${styles.input_header}`}>{title}</div>
        <input
          type="number"
          name={name}
          value={value}
          onChange={changeHandler}
          onKeyDown={removeSymbolNumberHandler}
          className={`bg-light py-2 ps-5 pe-2 ${styles.input_meter}`}
          style={{ textAlign: "right" }}
        />
      </div>
    </>
  );

  function removeSymbolNumberHandler(e) {
    const removeSymbolNumber = ["e", "E", ".", "-"];

    if (removeSymbolNumber.includes(e.key)) {
      e.preventDefault();
    }
  }
}
